module.exports = __webpack_public_path__ + "img/big_asset.3386d363.svg";